import { formRequest } from 'cupshe-axios'

export function material_upload_post(map, option) {
  return formRequest(
    `${process.env.VUE_APP_CMS}/cms/material/upload`,
    map,
    option
  ).then(response => response)
}
